import React, { useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageForm from "components/pageForm";
import Button from "components/button";
import UseContext from "hooks/useContext";
import ApiDataBase from "server";

// Test entry to the "mission created" page, outside production only: opens it on the company's
// latest mission. To remove once the page is approved.
const MissionCreatedPreviewButton = () => {
    const navigate = useNavigate();
    const { companyData, language } = UseContext();
    const [isLoading, setIsLoading] = useState(false);

    const openPreview = () => {
        if (!companyData?._id || isLoading) return;
        setIsLoading(true);
        ApiDataBase.getMissions({ idC: companyData._id },
            (missions) => {
                setIsLoading(false);
                const latest = (Array.isArray(missions) ? missions : [])
                    .slice()
                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
                if (!latest?._id) {
                    toast.info(language.getValue('missionCreated.previewEmpty', 'Aucune mission à afficher'));
                    return;
                }
                navigate(`/missionCreated/${latest._id}`);
            },
            () => {
                setIsLoading(false);
                toast.error(language.getValue('missionCreated.loadError', 'Impossible de charger la mission'));
            }
        );
    };

    return (
        <div className="absolute right-6 top-4 z-10">
            <Button size={'SM'} color={'SECONDARY'} onClick={openPreview} disabled={isLoading}>
                {language.getValue('missionCreated.previewButton', 'Tester l\'écran « Mission créée »')}
            </Button>
        </div>
    );
};

const Dashboard = () => {
    const { companyData } = UseContext();

    const getUserId = () => {
        const token = localStorage.getItem('xsrfToken');
        if (!token) return '';
        try {
            const decoded = jwtDecode(token);
            return decoded?.id || '';
        } catch {
            return '';
        }
    };

    const userId = getUserId();
    const companyId = companyData?._id || '';
    const retoolUrl = companyId
        ? `https://jobbiz.retool.com/embedded/public/020f3b9e-6d09-4baa-aa75-b7c8b3eedcae?userId=${userId}&companyId=${companyId}`
        : '';

    return (
        <PageForm>
            <div className="relative h-full w-full flex flex-col">
                {process.env.REACT_APP_IS_PROD !== 'true' ? <MissionCreatedPreviewButton/> : null}
                {retoolUrl ? (
                    <iframe
                        src={retoolUrl}
                        width="100%"
                        height="100%"
                        style={{ border: 'none', flex: 1 }}
                        title="Tableau de bord Retool"
                    />
                ) : (
                    <div className="flex items-center justify-center flex-1">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
                    </div>
                )}
            </div>
        </PageForm>
    );
};

export default Dashboard;